import { render } from "./WxIcon.vue?vue&type=template&id=5b330d16"
import script from "./WxIcon.vue?vue&type=script&lang=js"
export * from "./WxIcon.vue?vue&type=script&lang=js"

import "./WxIcon.vue?vue&type=style&index=0&id=5b330d16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__